import React from 'react';
import PropTypes from 'prop-types';
import Heading from './Heading';
import {
  HeaderContainer,
  AccentLine,
  Subtitle,
} from './Header.style';

export default function Header({ title, subtitle, color, align, showAccent, ...rest }) {
  return (
    <HeaderContainer $align={align} {...rest}>
      {showAccent && <AccentLine />}
      <Heading color={color}>{title}</Heading>
      {subtitle && <Subtitle color={color}>{subtitle}</Subtitle>}
    </HeaderContainer>
  );
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  color: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  showAccent: PropTypes.bool,
};

Header.defaultProps = {
  subtitle: '',
  color: '',
  align: 'center',
  showAccent: true,
};
